import LifgateCell from './container';

export default LifgateCell;
